module.exports = "<uib-progressbar value=\"$ctrl.value\" type=\"{{$ctrl.type}}\"><b>{{$ctrl.value | number:0}}%</b></uib-progressbar>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vehicle/manage-my-rlink/components/progressbar/progressbar.html
// module id = 1208
// module chunks = 0